import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, CircularProgress, Button } from '@material-ui/core';

import Dialog from '../../../common/dialog/dialog';
import NewPatient from './newPatientDialog';

import ClinicianSelectDefault from '../../../common/form/ClinicianSelectDefault';
import firebase from '../../../../config/firebase';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 8,
    width: '100%',
    position: 'relative',
    height: 60,
    [theme.breakpoints.down(1000)]: {
      width: '100%',
      alignItems: 'center'
    }
  },
  cont_one: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down(1000)]: {
      alignItems: 'center'
    }
  },
  cont_oneB: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  count: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.up(1000)]: {
      width: 600
    },
    [theme.breakpoints.down(700)]: {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  button: {
    width: 300,
    padding: 15,
    textTransform: 'none',
    '&:active': {
      backgroundColor: theme.palette.secondary.main_two
    },
    '&:focus': {
      backgroundColor: theme.palette.secondary.main_two
    },
    '&:hover': {
      backgroundColor: theme.palette.secondary.main_two
    },
    backgroundColor: theme.palette.secondary.main_two,
    color: '#ffffff'
  }
});

function TopMainPage({
  classes,
  loginState,
  portalConfig,
  patientsCount,
  showSpinner,
  partnerList,
  setPartnerInfo
}) {
  const [open, setOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState('invite');
  const [partner, setPartner] = useState({});
  const [loading, setLoading] = useState(false);

  const { user: { email } } = loginState;
  const { role } = portalConfig;

  const openDialog = () => {
    // Build years array for the dialog
    const currentYear = new Date().getFullYear();
    let years = [];
    let startYear = 1920;
    while (startYear <= currentYear - 18) {
      // eslint-disable-next-line no-plusplus
      years.push(startYear++);
    }
    years = years.reverse();

    return (
      <Dialog scroll="paper" close={() => setOpen(false)}>
        <NewPatient
          partners={partnerList}
          close={() => setOpen(false)}
          type={dialogMode}
          years={years}
          config={{ role, email }}
        />
      </Dialog>
    );
  };

  useEffect(() => {
    setLoading(true);
    const getPartner = firebase
      .functions()
      .httpsCallable('dashboardFunctions-getPartner');
    getPartner({
      id: partnerList[0]
    })
      .then(result => {
        if (result.status) {
          // error
          setLoading(false);
          return;
        }
        setPartner(result.data);
        setPartnerInfo(result.data);
        setLoading(false);
      })
      .catch(e => {
        console.log(e);
        setLoading(false);
      });
  }, [partnerList]);

  return (
    <div className={classes.root}>
      <div className={classes.cont_one}>
        <div className={classes.cont_oneB}>
          <Typography className={classes.count} color="inherit" variant="body1">
            Total Registered Patients:
            <div style={{ width: 5 }} />
            {showSpinner && patientsCount === -1 ? (
              <CircularProgress size={20} />
            ) : (
              <Typography
                style={{ fontWeight: 700 }}
                color="inherit"
                variant="body1"
              >
                {patientsCount}
              </Typography>
            )}
          </Typography>
          {(role === 'super' || role === 'admin') && (
            <Typography
              className={classes.count}
              color="inherit"
              variant="body1"
            >
              By Default, new patients are followed by: &nbsp;&nbsp;
              {loading ? (
                <CircularProgress size={20} />
              ) : (
                <ClinicianSelectDefault
                  data={partner}
                  onChange={d => {
                    partner.defaultPatientClinician = d.defaultPatientClinician;
                    setPartner(partner);
                  }}
                />
              )}
            </Typography>
          )}
        </div>

        <div style={{ flex: 1 }} />
        {/* <Button
          style={{ width: 300, padding: 15, textTransform: 'none' }}
          variant="outlined"
        >
          View Email Invitation Template
        </Button> */}
        {portalConfig.newPatientOptions &&
        portalConfig.newPatientOptions.indexOf('invite') >= 0 ? (
          <Button
            onClick={() => {
              setDialogMode('invite');
              setOpen(true);
            }}
            className={classes.button}
          >
            Invite New Patient
          </Button>
        ) : (
          <></>
        )}

        {portalConfig.newPatientOptions &&
        portalConfig.newPatientOptions.indexOf('preregistration') >= 0 ? (
          <Button
            style={{ marginLeft: 10 }}
            onClick={() => {
              setDialogMode('register');
              setOpen(true);
            }}
            className={classes.button}
          >
            Pre-register New Patient
          </Button>
        ) : (
          <></>
        )}
        {open === true ? openDialog() : ''}
      </div>
    </div>
  );
}

TopMainPage.propTypes = {
  classes: PropTypes.object,
  loginState: PropTypes.object,
  portalConfig: PropTypes.object,
  patientsCount: PropTypes.number,
  showSpinner: PropTypes.bool,
  partnerList: PropTypes.array,
  setPartnerInfo: PropTypes.func
};

export default withStyles(styles)(TopMainPage);
